import { IMAGE_ASPECT_RATIO_ID, IMAGE_ASPECT_RATIO_ID_TO_VALUE } from 'components/Image/constants'

export default function getHeightFromWidthImageUtil (
  width,
  aspectRatio = IMAGE_ASPECT_RATIO_ID.WIDE
) {
  const ratio = IMAGE_ASPECT_RATIO_ID_TO_VALUE[aspectRatio]
  return width
    ? width * ratio / 100
    : undefined
}
